import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import SvgTextureLineShort from 'js/components/svg/Svg.texture_line_short';
import { staticImageAssets } from 'js/constants/Paths';

import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';

// import actions
import { setPopupVideoId } from 'js/store/videos/Videos.actions';
import { toggleDisplayEntry } from 'js/store/gallery/Gallery.actions';

const variants = {
  hidden: {
    opacity: 0,
    scale: 0, // Start scale at 0
  },
  visible: (index) => ({
    opacity: 1,
    scale: 1, // End scale at 1
    rotate: [0, 4, -4, 0], // Rotate between 0 and 4 degrees
    transition: {
      type: 'spring', // Use spring for a bounce effect
      stiffness: 120, // Tightness of the spring
      damping: 10, // Control the spring bounce
      delay: Math.random() * 0.8 + 0.2, // Alternate delay logic
    },
  }),
};

const ContentItemBlock = ({ item }) => {
  const dispatch = useDispatch();

  const { name = '', description = '', imageUrl = '', link = '', id, type, age } = item;
  const controls = useAnimation();

  const { ref, inView } = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  React.useEffect(() => {
    inView ? controls.start('visible') : controls.start('hidden');
  }, [inView]);

  const triggerVideoOverlay = () => {
    dispatch(setPopupVideoId(id));
  };

  return (
    <motion.li
      className={`content-item__item content-item__item--${type || 'default'}`}
      key={name}
      variants={variants}
      initial="hidden"
      animate={controls}
      ref={ref}
    >
      <div className={`content-item content-item--${type || 'default'}`}>
        {type === 'video' ? (
          <div
            onClick={triggerVideoOverlay}
            style={{ cursor: 'pointer', height: '100%', display: 'flex', flexDirection: 'column' }}
          >
            <div className="content-item__video">
              <img
                className="content-item__play-button"
                src={staticImageAssets('images/static/button_play.png')}
                alt={'play button icon'}
                title={'play button icon'}
              />
              <figure>
                <img src={imageUrl} alt={description} title={description} />
              </figure>
            </div>

            <div className="content-item__body">
              <h2>{name}</h2>
            </div>
          </div>
        ) : type == 'gallery' ? (
          <div
            onClick={() => {
              dispatch(toggleDisplayEntry(id));
            }}
            style={{ cursor: 'pointer', height: '100%', display: 'flex', flexDirection: 'column' }}
          >
            <figure>
              <img src={imageUrl} alt={description} title={description} />
            </figure>
            <div className="content-item__body">
              <h2>
                {name}
                {age ? `, Age ${age}` : ''}
              </h2>
            </div>
          </div>
        ) : (
          <a href={link} target="_blank" rel="noreferrer">
            <figure>
              <img src={imageUrl} alt={description} title={description} />
            </figure>
            <div className="content-item__body">
              <h2>{name}</h2>
              <h3>{description}</h3>
            </div>
          </a>
        )}
      </div>
    </motion.li>
  );
};

export default ContentItemBlock;
